/** Button.tsx — shared button. Static class literals per variant/size. */

import type { ButtonHTMLAttributes } from 'react';

export type ButtonVariant = 'primary' | 'secondary' | 'danger' | 'ghost';
export type ButtonSize = 'sm' | 'md';

const VARIANT_CLASSES: Record<ButtonVariant, string> = {
  primary: 'bg-gold text-on-gold hover:bg-gold-mute max-md:min-h-11',
  secondary: 'bg-surface-2 text-ink-1 ring-1 ring-inset ring-ink-3/20 hover:bg-surface-1',
  danger:
    'bg-status-down/15 text-status-down ring-1 ring-inset ring-status-down/40 hover:bg-status-down/25',
  ghost: 'text-ink-2 hover:bg-surface-2',
};

const SIZE_CLASSES: Record<ButtonSize, string> = {
  sm: 'px-3 py-1 text-meta',
  md: 'px-4 py-1.5 text-body',
};

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
}

export const Button = ({
  variant = 'secondary',
  size = 'md',
  type = 'button',
  className = '',
  ...rest
}: ButtonProps) => (
  <button
    // eslint-disable-next-line react/jsx-props-no-spreading -- primitive forwards native HTML attributes (data-testid, aria-*) to the root element
    {...rest}
    // eslint-disable-next-line react/button-has-type -- `type` defaults to 'button' and is typed to the native union
    type={type}
    className={`inline-flex items-center justify-center rounded-lg font-medium focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-outline-focus disabled:opacity-60 ${VARIANT_CLASSES[variant]} ${SIZE_CLASSES[size]} ${className}`.trim()}
  />
);
